import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ClipboardService {
  copiedText: string | null = null;
  copiedId: string | null = null;

  copyToClipboard(text: string, event: MouseEvent, id?: number): Promise<void> {
    event.stopPropagation();
    return navigator.clipboard.writeText(text).then(() => {
      this.copiedText = id?.toString() ?? text;
      setTimeout(() => this.copiedText = null, 1000);
    });
  }

  copyToClipboardDeviceManagement(text: string, event: MouseEvent, id: string): Promise<void> {
    event.stopPropagation();
    return navigator.clipboard.writeText(text).then(() => {
      this.copiedId = id;
      setTimeout(() => this.copiedId = null, 1000);
    });
  }
}